import { Icon } from 'components/Icon';
import { LANGUAGES } from 'utils/constants';

import { LanguageLinksItem } from './LanguageLinksItem';

type Props = {
  className?: string;
  url: Record<string, string>;
  showIcon?: boolean;
};

export function LanguageLinks({ className, url, showIcon = true }: Props) {
  return (
    <div className={className}>
      {showIcon && <Icon name="line-globe" size={16} />}

      {(Object.keys(LANGUAGES) as UserLocale[]).map((locale) => (
        <LanguageLinksItem
          key={locale}
          locale={locale}
          localeUrl={url[locale]}
        />
      ))}
    </div>
  );
}
